import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';

import LoginModal from '@/components/molecules/LoginModal';
import useModal from '@/hooks/useModal';
import { MODAL_BUTTON_TYPE, MODAL_TYPE } from '@/types/modal';
import { getPageName, logger } from '@/utils/logger';
import { NATIVE_POST_MESSAGE_TYPE, historyBack, isWebView, sendPostMessageToNative } from '@/utils/mobile/RNPlugins';

const useAuthModal = (canOverlayClick = false, isWritePage = false) => {
  const router = useRouter();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { showModal, closeModal } = useModal();
  const [trackInfo, setTrackInfo] = useState({
    campaign: '',
    content: '',
    buttonText: '',
  });

  const isRouteBackPath = router.pathname.includes('/content/qna/write');

  const onClickCancel = useCallback(() => {
    setShowAuthModal(false);
    closeModal();
    if (isWebView() && isRouteBackPath) {
      historyBack();
    }
  }, [closeModal, isRouteBackPath]);

  /** for Webview  */
  const onClickLogin = () => {
    if (isWebView()) {
      sendPostMessageToNative(NATIVE_POST_MESSAGE_TYPE.MOVE_TO_LOGIN);
      setShowAuthModal(false);
      closeModal();
    }
  };

  useEffect(() => {
    if (showAuthModal) {
      logger({
        eventName: 'sns_login',
        pageName: getPageName(router),
      });

      if (!isWebView()) {
        showModal({
          type: MODAL_TYPE.BASIC,
          props: {
            body: <LoginModal isWritePage={isWritePage} onClick={onClickCancel} trackInfo={trackInfo} />,
            onClickOverlay: canOverlayClick ? onClickCancel : undefined,
          },
        });
      } else {
        showModal({
          type: MODAL_TYPE.ALERT,
          props: {
            title: '로그인이 필요해요',
            message: '서비스 이용을 위해 로그인해 주세요.',
            buttons: [
              {
                label: '닫기',
                onClick: () => onClickCancel(),
              },
              {
                type: MODAL_BUTTON_TYPE.PRIMARY,
                label: '로그인',
                onClick: () => onClickLogin(),
              },
            ],
          },
        });
      }
    }
  }, [showAuthModal]);

  useEffect(() => {
    const close = () => {
      closeModal();
    };

    window.addEventListener('popstate', close);

    return () => {
      window.removeEventListener('popstate', close);
    };
  });

  return {
    setShowAuthModal,
    setTrackInfo,
    trackInfo,
  };
};

export default useAuthModal;
